import { ErrorHandler } from '@apollo/client/link/error';
import { GraphQLErrors } from '@apollo/client/errors';

import { DEFAULT_ERROR_HANDLER } from './graphql.constants';

import { ToastService } from '@iss/core/portal';

// We've got msg from backend in a form like
// 'com.issworld.wo.ordering.service.editing.scheduled_order_editing.ScheduledOrderEditException: Scheduled Order has an active negotiation'
// We would like to skip the text from the beginning to the ": " place to have msg like 'Scheduled Order has an active negotiation'.
const extractMsg = (msg: string): string => msg.split(':')[1].trim() || '';
const findMsg = (errors: GraphQLErrors): string => errors.map(e => extractMsg(e.message)).join('. ');

const isFunction = (value: unknown): value is () => unknown => typeof value === 'function';

export const createErrorHandler = (toast: ToastService): ErrorHandler => {
  return ({ graphQLErrors, networkError, operation }) => {
    const ctx = operation.getContext();
    const defaultErrorHandler: unknown = ctx[DEFAULT_ERROR_HANDLER];

    if (isFunction(defaultErrorHandler)) {
      const msg = graphQLErrors ? findMsg(graphQLErrors) : undefined;
      if (msg) {
        toast.error(msg, { withoutTranslation: true });
      } else if (networkError) {
        toast.error('iss-wo-common.error.http-error');
      } else {
        defaultErrorHandler();
      }
    }
  };
};
